import axios from "axios";
import * as ROUTES from "@/constants/route";

type NormalizeLegacyClientOnLoginParams = {
  token: string;
};

export const normalizeLegacyClientOnLogin = ({
  token,
}: NormalizeLegacyClientOnLoginParams): Promise<void> => {
  return axios
    .post(
      `${ROUTES.FUNCTION_BASE_URL}v2/users/me/normalize-legacy`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then(() => undefined);
};
